import {TrendingUp} from 'lucide-react'

interface FooterProps {
  navigate: (path: string) => void
}

function Footer({ navigate }: FooterProps) {
  const year = new Date().getFullYear()

  return (
    <footer className="bg-slate-950 text-slate-400">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-emerald-600 text-white">
                <TrendingUp className="w-4 h-4" strokeWidth={2.5} />
              </span>
              <span className="text-[15px] font-extrabold text-white tracking-tight">AdsROAS</span>
            </div>
            <p className="text-[13px] leading-relaxed text-slate-400 max-w-xs">
              Independent calculators for media buyers, agencies, and e-commerce operators who need a clear view of advertising return.
            </p>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold text-slate-200 uppercase tracking-[0.16em] mb-4">Free Tools</h3>
            <ul className="space-y-2.5 text-[13px]">
              <li><button onClick={() => navigate("/")} className="hover:text-emerald-400 transition-colors">Master ROAS Calculator</button></li>
              <li><button onClick={() => navigate("/calculators/break-even")} className="hover:text-emerald-400 transition-colors">Break-Even ROAS</button></li>
              <li><button onClick={() => navigate("/calculators/google-ads")} className="hover:text-emerald-400 transition-colors">Google Ads ROAS</button></li>
              <li><button onClick={() => navigate("/calculators/facebook-ads")} className="hover:text-emerald-400 transition-colors">Facebook Ads ROAS</button></li>
              <li><button onClick={() => navigate("/calculators/acos-converter")} className="hover:text-emerald-400 transition-colors">ACoS Converter</button></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold text-slate-200 uppercase tracking-[0.16em] mb-4">Resources</h3>
            <ul className="space-y-2.5 text-[13px]">
              <li><button onClick={() => navigate("/blog")} className="hover:text-emerald-400 transition-colors">Blog</button></li>
              <li><button onClick={() => navigate("/faq")} className="hover:text-emerald-400 transition-colors">FAQ</button></li>
              <li><button onClick={() => navigate("/about")} className="hover:text-emerald-400 transition-colors">About</button></li>
              <li><button onClick={() => navigate("/contact")} className="hover:text-emerald-400 transition-colors">Contact</button></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold text-slate-200 uppercase tracking-[0.16em] mb-4">Compliance</h3>
            <ul className="space-y-2.5 text-[13px]">
              <li><button onClick={() => navigate("/terms")} className="hover:text-emerald-400 transition-colors">Terms of Service</button></li>
              <li><button onClick={() => navigate("/privacy")} className="hover:text-emerald-400 transition-colors">Privacy Policy</button></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 text-[12px] text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <p>&copy; {year} Ads ROAS Calculator. All rights reserved.</p>
          <p>adsroascalculator.com — Independent ad-tech utility.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
